import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { FundProspectusLinksDCR } from '@ddt-web/config';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { ComponentData, TableData } from '@ddt-web/data-service';
import * as get from 'lodash/get';
import * as sortBy from 'lodash/sortBy';
import * as uniqBy from 'lodash/uniqBy';

@Component({
	selector: 'dl-prospectus-links',
	templateUrl: './prospectus-links.component.html',
	styleUrls: ['./prospectus-links.component.scss']
})
export class ProspectusLinksComponent implements OnInit, OnChanges {
	@Input() public data: ComponentData;
	@Input() public additionFundsData?: { [componentId: string]: ComponentData };

	@InjectConfig(SharedConfigKey.SHOW_FUND_PROSPECTUS) public readonly showFundProspectus: boolean = false;

	public baseUrl: string;
	public fundsToShow: { ticker: string; cusip: string }[] = [];

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		this.baseUrl = this.contentService.get('FUND_PROSPECTUS_BASE_URL', FundProspectusLinksDCR.FUND_PROSPECTUS_BASE_URL);
	}
	public ngOnChanges(): void {
		if (!this.showFundProspectus) {
			return;
		}

		this.fundsToShow.length = 0;
		const tableData = this.data.getTabById('fund.prospectus').tableData[0];
		this.generateFundToShow(tableData);
		if (this.additionFundsData) {
			Object.values(this.additionFundsData)
				.filter(additionData => additionData.id !== 'fund.prospectus')
				.forEach(additionData => {
					const additionTableData = get(additionData, 'tabs[0].tableData[0]');
					if (additionTableData) {
						this.generateFundToShow(additionTableData);
					}
				});
		}
	}

	public generateFundToShow(tableData: TableData): void {
		const result = tableData.headersY
			.map((fund, index) => {
				return {
					ticker: fund.formattedValue,
					cusip: get(tableData, `cells[${index}][0].formattedValue`)
				};
			})
			.filter(result => result.ticker && result.cusip);
		this.fundsToShow.push(...result);
		const uniqFundsToShow = uniqBy(this.fundsToShow, 'ticker');
		const sortedUniqFundsToShow = sortBy(uniqFundsToShow, 'ticker');
		this.fundsToShow = sortedUniqFundsToShow;
	}
}
